/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The WalletControllerDtoDashboardSummaryResponse model module.
 * @module model/WalletControllerDtoDashboardSummaryResponse
 * @version 1.0
 */
class WalletControllerDtoDashboardSummaryResponse {
    /**
     * Constructs a new <code>WalletControllerDtoDashboardSummaryResponse</code>.
     * @alias module:model/WalletControllerDtoDashboardSummaryResponse
     */
    constructor() { 
        
        WalletControllerDtoDashboardSummaryResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoDashboardSummaryResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoDashboardSummaryResponse} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoDashboardSummaryResponse} The populated <code>WalletControllerDtoDashboardSummaryResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoDashboardSummaryResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('realtimeHvh')) {
                obj['realtimeHvh'] = ApiClient.convertToType(data['realtimeHvh'], 'Number');
            }
            if (data.hasOwnProperty('realtimePer')) {
                obj['realtimePer'] = ApiClient.convertToType(data['realtimePer'], 'Number');
            }
            if (data.hasOwnProperty('realtimeXper')) {
                obj['realtimeXper'] = ApiClient.convertToType(data['realtimeXper'], 'Number');
            }
            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('availableBalanceHvh')) {
                obj['availableBalanceHvh'] = ApiClient.convertToType(data['availableBalanceHvh'], 'Number');
            }
            if (data.hasOwnProperty('availableBalancePer')) {
                obj['availableBalancePer'] = ApiClient.convertToType(data['availableBalancePer'], 'Number');
            }
            if (data.hasOwnProperty('availableBalanceXper')) {
                obj['availableBalanceXper'] = ApiClient.convertToType(data['availableBalanceXper'], 'Number');
            }
            if (data.hasOwnProperty('coldWalletBalanceHvh')) {
                obj['coldWalletBalanceHvh'] = ApiClient.convertToType(data['coldWalletBalanceHvh'], 'Number');
            }
            if (data.hasOwnProperty('coldWalletBalancePer')) {
                obj['coldWalletBalancePer'] = ApiClient.convertToType(data['coldWalletBalancePer'], 'Number');
            }
            if (data.hasOwnProperty('coldWalletBalanceXper')) {
                obj['coldWalletBalanceXper'] = ApiClient.convertToType(data['coldWalletBalanceXper'], 'Number');
            }
            if (data.hasOwnProperty('xperAlert')) {
                obj['xperAlert'] = ApiClient.convertToType(data['xperAlert'], 'String');
            }
            if (data.hasOwnProperty('perAlert')) {
                obj['perAlert'] = ApiClient.convertToType(data['perAlert'], 'String');
            }
            if (data.hasOwnProperty('hvhAlert')) {
                obj['hvhAlert'] = ApiClient.convertToType(data['hvhAlert'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoDashboardSummaryResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoDashboardSummaryResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['xperAlert'] && !(typeof data['xperAlert'] === 'string' || data['xperAlert'] instanceof String)) {
            throw new Error("Expected the field `xperAlert` to be a primitive type in the JSON string but got " + data['xperAlert']);
        }
        // ensure the json data is a string
        if (data['perAlert'] && !(typeof data['perAlert'] === 'string' || data['perAlert'] instanceof String)) {
            throw new Error("Expected the field `perAlert` to be a primitive type in the JSON string but got " + data['perAlert']);
        }
        // ensure the json data is a string
        if (data['hvhAlert'] && !(typeof data['hvhAlert'] === 'string' || data['hvhAlert'] instanceof String)) {
            throw new Error("Expected the field `hvhAlert` to be a primitive type in the JSON string but got " + data['hvhAlert']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
WalletControllerDtoDashboardSummaryResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
WalletControllerDtoDashboardSummaryResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
WalletControllerDtoDashboardSummaryResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
WalletControllerDtoDashboardSummaryResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
WalletControllerDtoDashboardSummaryResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} realtimeHvh
 */
WalletControllerDtoDashboardSummaryResponse.prototype['realtimeHvh'] = undefined;

/**
 * @member {Number} realtimePer
 */
WalletControllerDtoDashboardSummaryResponse.prototype['realtimePer'] = undefined;

/**
 * @member {Number} realtimeXper
 */
WalletControllerDtoDashboardSummaryResponse.prototype['realtimeXper'] = undefined;

/**
 * @member {Date} targetDate
 */
WalletControllerDtoDashboardSummaryResponse.prototype['targetDate'] = undefined;

/**
 * @member {Number} availableBalanceHvh
 */
WalletControllerDtoDashboardSummaryResponse.prototype['availableBalanceHvh'] = undefined;

/**
 * @member {Number} availableBalancePer
 */
WalletControllerDtoDashboardSummaryResponse.prototype['availableBalancePer'] = undefined;

/**
 * @member {Number} availableBalanceXper
 */
WalletControllerDtoDashboardSummaryResponse.prototype['availableBalanceXper'] = undefined;

/**
 * @member {Number} coldWalletBalanceHvh
 */
WalletControllerDtoDashboardSummaryResponse.prototype['coldWalletBalanceHvh'] = undefined;

/**
 * @member {Number} coldWalletBalancePer
 */
WalletControllerDtoDashboardSummaryResponse.prototype['coldWalletBalancePer'] = undefined;

/**
 * @member {Number} coldWalletBalanceXper
 */
WalletControllerDtoDashboardSummaryResponse.prototype['coldWalletBalanceXper'] = undefined;

/**
 * @member {String} xperAlert
 */
WalletControllerDtoDashboardSummaryResponse.prototype['xperAlert'] = undefined;

/**
 * @member {String} perAlert
 */
WalletControllerDtoDashboardSummaryResponse.prototype['perAlert'] = undefined;

/**
 * @member {String} hvhAlert
 */
WalletControllerDtoDashboardSummaryResponse.prototype['hvhAlert'] = undefined;






export default WalletControllerDtoDashboardSummaryResponse;

